import { BaseAction } from '../../store/actions';
import { ConfigUpdateItem } from '../../shared/models/organization';

export enum OrganizationActions {
  UpdateOrgConfig = '[Organization] Update Config',
  UpdateOrgConfigSuccess = '[Organization] Update Config Success',
  UpdateOrgConfigError = '[Organization] Update Config Error',
}

export class UpdateOrgConfig implements BaseAction<OrganizationActions> {
  readonly type = OrganizationActions.UpdateOrgConfig;

  constructor(public readonly updates: ConfigUpdateItem[]) {}
}

export class UpdateOrgConfigSuccess implements BaseAction<OrganizationActions> {
  readonly type = OrganizationActions.UpdateOrgConfigSuccess;
}

export class UpdateOrgConfigError implements BaseAction<OrganizationActions> {
  readonly type = OrganizationActions.UpdateOrgConfigError;

  constructor(public readonly payload: string) {}
}

export type OrganizationAction = UpdateOrgConfig | UpdateOrgConfigSuccess | UpdateOrgConfigError;
